var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('logo-title',{attrs:{"hotKeyWords":_vm.hotKeyWords,"url":"http://goabroad.xdf.cn/xinban/","logoPos":"background-position: 4px -410px"}}),_vm._v(" "),_c('swiper'),_vm._v(" "),_c('keep-alive',[_c('cart')],1),_vm._v(" "),_c('main-floor'),_vm._v(" "),_c('living',{attrs:{"title":"精品直播","listObj":_vm.gobroadLiving}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-370e52fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/gobroad/Gobroad.vue
// module id = null
// module chunks = 